import { render, staticRenderFns } from "./field_particulars.vue?vue&type=template&id=7bf98556&scoped=true&"
import script from "./field_particulars.vue?vue&type=script&lang=js&"
export * from "./field_particulars.vue?vue&type=script&lang=js&"
import style0 from "./field_particulars.vue?vue&type=style&index=0&id=7bf98556&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf98556",
  null
  
)

export default component.exports